/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
import emojiData from "./emoji-data";
import styles from "./styles";

export function toCode(str) {
  return str.replace(/emo:(\w+)\//g, (corr, p) => {
    return String.fromCodePoint(p);
  });
}

/**
 * EmojiBoard Component
 */
function EmojiBoard(props) {
  const { addEmoji } = props;

  const onClick = code => event => {
    event.preventDefault();
    addEmoji(`emo:${code}/`);
  };

  // CSS classnames
  const classes = styles();

  return (
    <div className={classes.root}>
      {emojiData.map((code, index) => (
        <div
          key={index.toString()}
          className={classes.emoji}
          onClick={onClick(code)}
        >
          {String.fromCodePoint(code)}
        </div>
      ))}
    </div>
  );
}

export default EmojiBoard;
